import { Injectable } from '@angular/core';
import { LMStatePersistenceService } from '@services/lm-state-persistence.service';

@Injectable()
export class LMListStateService {
  constructor(private lmStatePersistenceService: LMStatePersistenceService) {}

  public hasListState(listStateKeyParams: LMListStateKeyParams): boolean {
    return this.lmStatePersistenceService.hasState(listStateKeyParams.getKey());
  }

  public getListState(listStateKeyParams: LMListStateKeyParams): LMListState {
    return this.lmStatePersistenceService.getState(listStateKeyParams.getKey()) as LMListState;
  }

  public saveListState(listStateKeyParams: LMListStateKeyParams, listStateItem: LMListState): void {
    this.lmStatePersistenceService.persistState(listStateKeyParams.getKey(), listStateItem);
  }

  public deleteListState(listStateKeyParams: LMListStateKeyParams): void {
    return this.lmStatePersistenceService.removeState(listStateKeyParams.getKey());
  }
}

export class LMListStateKeyParams {
  actorId?: string;
  asOfDate?: string;
  dataArea: string;
  routeResourceId: string;
  resourceId: string;
  contextResourceId?: string;
  prefix?: string;
  userFolder?: string;

  private key = '';

  getKey() {
    if (!this.key) {
      this.buildKey();
    }
    return this.key;
  }

  private buildKey(): void {
    const stringArray = new Array<string>();

    if (this.actorId) {
      stringArray.push(this.actorId);
    }
    if (this.asOfDate) {
      stringArray.push(this.asOfDate);
    }

    stringArray.push(this.dataArea);
    stringArray.push(this.routeResourceId);

    if (this.resourceId !== this.routeResourceId) {
      // must be a listPanel
      stringArray.push(this.resourceId);
    }

    if (this.contextResourceId) {
      stringArray.push(this.contextResourceId);
    }

    if (this.userFolder) {
      stringArray.push(this.userFolder);
    }

    this.key = stringArray.join('_');
  }
}
